import React from 'react';
import { TableCell, TableRow, Typography, Stack } from '@mui/material';
import { Schedule } from 'store/schedules/interfaces';
import NavigateButton from 'common/NavigateButton/NavigateButton';
import { useTranslation, Trans } from 'react-i18next';
import getWorkingTime from 'components/UserWorkingHours/getWorkingTime';
import { daysInWeek } from 'helpers/timeConsts';
import ScheduleWorkingDays from 'components/ScheduleWorkingDays/ScheduleWorkingDays';

interface WorkScheduleItemProps {
  schedule: Schedule;
}

export default function WorkScheduleItem({ schedule }: WorkScheduleItemProps) {
  const { t } = useTranslation();
  const secondsForWholeRanges = schedule.scheduleRanges.reduce(
    (acc, scheduleRange) =>
      acc + (scheduleRange.timeTo - scheduleRange.timeFrom),
    0,
  );

  const secondsPerWeek = Math.round(
    (secondsForWholeRanges * daysInWeek) / schedule.numberOfDays,
  );

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2" fontWeight={700}>
          {schedule.name}
        </Typography>
      </TableCell>
      <TableCell>
        {schedule.regular ? (
          <Stack direction="row">
            <Trans
              i18nKey="project_tracking.regular_type_label"
              values={{ duration: getWorkingTime(secondsPerWeek) }}
              components={{
                bold: (
                  <Typography
                    variant="body2"
                    fontWeight={700}
                    marginRight={0.25}
                  />
                ),
                span: (
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    color="text.secondary"
                  />
                ),
              }}
            />
          </Stack>
        ) : (
          <Typography variant="body2" fontWeight={700}>
            {t('project_tracking.irregular_type_label')}
          </Typography>
        )}
      </TableCell>
      <TableCell>
        <ScheduleWorkingDays schedule={schedule} primary />
      </TableCell>
      <TableCell>
        <Typography variant="body2" fontWeight={700}>
          {schedule.employees.length}
        </Typography>
      </TableCell>
      <TableCell>
        <NavigateButton
          to={`/work-schedules/${schedule.id}`}
          tooltipLabel={t('label.go_to', { name: schedule.name })}
        />
      </TableCell>
    </TableRow>
  );
}
